module.exports = __webpack_public_path__ + "img/sk.sk8ebdd96.svg";